import environment from "@/config/environment";
import axios from "axios";

class HTTPService {
	async sendGetRequest(url: string) {
		const res = await axios({
			method: "get",
			baseURL: environment.get("VITE_BASE_API_URL"),
			url: url,
			withCredentials: true,
			timeout: 10_000,
			headers: {
				accept: "application/json",
			},
		});

		if (res.status < 200 || res.status >= 300) {
			console.error(
				`HTTPService GET Error for ${url}: ${res.status} ${res.statusText}`
			);
		}

		return res.data;
	}

	async sendPostRequest(
		url: string,
		data: unknown,
		options: { timeout: number } = { timeout: 10_000 }
	) {
		const res = await axios({
			method: "post",
			baseURL: environment.get("VITE_BASE_API_URL"),
			url,
			data,
			withCredentials: true,
			timeout: options.timeout,
			headers: {
				accept: "application/json",
			},
		});

		return res.data;
	}

	async sendPutRequest(url: string, data: unknown) {
		const res = await axios({
			method: "put",
			baseURL: environment.get("VITE_BASE_API_URL"),
			url: url,
			data: data,
			withCredentials: true,
			timeout: 10_000,
			headers: {
				accept: "application/json",
			},
		});
		return res.data;
	}

	async sendDeleteRequest(url: string) {
		const res = await axios({
			method: "delete",
			baseURL: environment.get("VITE_BASE_API_URL"),
			url: url,
			withCredentials: true,
			timeout: 10_000,
			headers: {
				accept: "application/json",
			},
		});
		return res.data;
	}

	async sendFormDataPostRequest(
		url: string,
		formData: FormData
	): Promise<unknown> {
		// Return type might need adjustment based on backend response

		try {
			const res = await axios({
				method: "post",
				baseURL: environment.get("VITE_BASE_API_URL"),
				url: url,
				data: formData,
				withCredentials: true,
				timeout: 60_000,
				headers: {
					// IMPORTANT: Let axios set the Content-Type header for FormData
					// Do NOT set 'Content-Type': 'multipart/form-data' manually,
					// axios needs to set it along with the correct boundary.
					Accept: "application/json", // We still expect JSON response
				},
			});
			return res.data;
		} catch (error) {
			console.error(`HTTPService FormData POST Error for ${url}:`, error);
			throw error;
		}
	}
}

export default HTTPService;
